import React from 'react';
import _ from 'lodash';
import {DeleteModal} from 'app-ui-componentlibrary';
import {PAYMENT_PATH_ROOT, PRICE, QUANTITY} from 'common/requestDetails/constants';
import {Contexts} from 'componentLibrary';
import {safeMult} from 'common/utils';
import {
  calculateLineItemPaymentTotals,
  calculatePeriod,
  getPastPaymentsForLineItem,
} from 'common/requestDetails/utils';

const {RequestDetailsContext} = Contexts;

export const calculatePaymentTotals = (payments, sourcePath) => {
  const otherPaymentItems = _.map(payments, (payment) => {
    const otherItem = _.get(payment, `payload.paymentStreams.${sourcePath}`);
    return _.get(otherItem, PAYMENT_PATH_ROOT);
  });

  return _.reduce(
    otherPaymentItems,
    (acc, paymentItem) => {
      return _.reduce(
        paymentItem,
        (internalAcc, payment) => {
          return internalAcc + safeMult(_.get(payment, PRICE), _.get(payment, QUANTITY));
        },
        acc
      );
    },
    0
  );
};

export class LineItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteItemModalOpen: false,
    };
  }

  static contextType = RequestDetailsContext;

  openDeleteModal = () => this.setState({deleteItemModalOpen: true});
  closeDeleteModal = () => this.setState({deleteItemModalOpen: false});

  isNewlyCreated = () => {
    const {item} = this.props;
    return !!_.find(
      _.get(item, 'additionalInformation.changes', []),
      (change) => change.type === 'newlyCreated'
    );
  };

  canDelete = () => {
    return this.isNewlyCreated();
  };

  render() {
    const {
      editable,
      id,
      deleteItem,
      sourcePath,
      itemCodeOptions,
      itemConfig,
      tier,
      beingCreated,
      validationErrors,
      validationDirtyMap,
      handleChange,
      handleBlur,
      handleItemChange,
      handleItemChangeAndBlur,
      lineItem,
      canEdit,
      mode,
      displayFields,
      costType,
      costSectionHeader,
    } = this.props;

    const pastTotalPayment = calculateLineItemPaymentTotals(
      _.get(this.context, 'otherPayments', []),
      sourcePath
    );

    const pastPayments = getPastPaymentsForLineItem(
      _.get(this.context, 'otherPayments', []),
      sourcePath
    );

    const hasPayment =
      _.get(lineItem, [...PAYMENT_PATH_ROOT, 0, QUANTITY]) *
        _.get(lineItem, [...PAYMENT_PATH_ROOT, 0, PRICE]) >
      0;

    const filteredRoster = _.filter(
      _.get(this.context, 'roster'),
      (position) => position.awardedId === sourcePath
    );

    const totalsInfo = _.get(this.context, 'totalsInfo', {});
    const rootPath = _.get(this.context, 'entityDataPath') + '.' + sourcePath;
    const turnOffvalidationLimits = _.get(this.context, 'turnOffvalidationLimits');

    return (
      <React.Fragment>
        <DeleteModal
          displayTitle={`Remove ${_.get(itemConfig, 'labels.itemLabel', 'item')}`}
          open={this.state.deleteItemModalOpen}
          cancelAction={this.closeDeleteModal}
          deleteAction={() => deleteItem(sourcePath)}
          displayText={`Are you sure you want to remove this ${itemConfig.name} ${_.get(
            itemConfig,
            'labels.itemLabel',
            'item'
          )}?`}
        />
        {this.props.children({
          item: lineItem,
          handleBlur,
          handleChange,
          handleItemChange,
          handleItemChangeAndBlur,
          deletable: this.canDelete(),
          isNewlyCreated: this.isNewlyCreated(),
          editable: canEdit,
          beingCreated,
          id,
          itemConfig: {
            ...itemConfig,
            additionalQuestions: {
              ..._.get(itemConfig, 'additionalQuestions', {}),
              readOnlyContents: _.concat(
                _.get(itemConfig, 'additionalQuestions.readOnlyContents', []),
                _.get(itemConfig, 'extraAdditionalQuestions.readOnlyContents', [])
              ),
              contents: _.concat(
                _.get(itemConfig, 'additionalQuestions.contents', []),
                _.get(itemConfig, 'extraAdditionalQuestions.contents', [])
              ),
            },
          },
          hasPayment,
          itemCodeOptions,
          mode,
          period: calculatePeriod(itemConfig),
          pastTotalPayment,
          roster: filteredRoster,
          openDeleteModal: this.openDeleteModal,
          closeDeleteModal: this.closeDeleteModal,
          sourcePath,
          validationErrors,
          validationDirtyMap,
          rootPath,
          tier,
          displayFields,
          costType,
          costSectionHeader,
          paymentPeriod: _.get(this.context, 'paymentPeriod'),
          fundingOpportunityStreams: _.get(this.context, 'fundingOpportunityStreams'),
          staffingStreamType: _.get(this.context, 'staffingStreamType'),
          periodOfPerformance: _.get(this.context, 'periodOfPerformance'),
          approvedPayments: pastPayments,
          grantBudgetShareFedRate: _.get(this.context, 'grantBudgetShareFedRate'),
          totalsInfo,
          turnOffvalidationLimits,
        })}
      </React.Fragment>
    );
  }
}

export default LineItem;
